import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { LogbookEntry, UpsertLogbookEntryRequest } from 'shared';

const BASE = `${API_BASE_URL}/api/admin/logbook`;

export const logbookApi = {
  async list(): Promise<LogbookEntry[]> {
    const response = await axios.get(BASE);
    return response.data.data;
  },

  async create(req: UpsertLogbookEntryRequest): Promise<LogbookEntry> {
    const response = await axios.post(BASE, req);
    return response.data.data;
  },

  async update(id: string, req: UpsertLogbookEntryRequest): Promise<LogbookEntry> {
    const response = await axios.put(`${BASE}/${id}`, req);
    return response.data.data;
  },

  async remove(id: string): Promise<void> {
    await axios.delete(`${BASE}/${id}`);
  },

  async uploadImage(id: string, file: File): Promise<LogbookEntry> {
    const formData = new FormData();
    formData.append('image', file);
    const response = await axios.post(`${BASE}/${id}/image`, formData);
    return response.data.data;
  },

  async removeImage(id: string): Promise<LogbookEntry> {
    const response = await axios.delete(`${BASE}/${id}/image`);
    return response.data.data;
  },
};

export function logbookImageUrl(entry: LogbookEntry): string | null {
  if (!entry.image) return null;
  return `${API_BASE_URL}/api/public/logbook/images/${entry.image}`;
}

export function logbookErrorMessage(err: any, fallback: string): string {
  return err?.response?.data?.error?.message || fallback;
}
